import { DeviceOrientationEnum } from '../../shared/enum/device-orientation.enum';
import { IStoreUiState } from './ui.interface';

export default {
  uiOrientation: DeviceOrientationEnum.PORTRAIT,
  users: [],
  programs: [],
  downloadedVideo: [],
  dialogTrapStack: [],
  notificationTrapStack: [],
  csrfTokens: []
} as IStoreUiState;
